const Loi = () => {
  return (
    <div className='flex items-center justify-center pb-5'>
      <div className='tracking-normal text-base sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl 2xl:text-6xl'>
        <div>
          <h1 className='text-slate-50 pt-5 pb-2 flex items-center justify-center font-bold text-3xl sm:text-6xl sm:pb-5 md:text-7xl lg:text-8xl xl:text-9xl 2xl:text-9xl'>Lời Hứa Hướng Đạo</h1>
          <p className='text-slate-300 pt-5 leading-tight text-lg sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl'>
            Tôi xin lấy danh dự hứa cố gắng hết sức<br />
            Làm bổn phận đối với Tín ngưỡng<br />
            tâm linh và Quốc gia tôi,<br />
            Giúp đỡ mọi người bất cứ lúc nào,<br />
            Tuân theo Luật Hướng đạo.
          </p>
        </div>
        <div className='pt-5 2xl:pt-10'>
          <h1 className='text-slate-50 pt-5 pb-2 flex items-center justify-center font-bold text-2xl sm:text-5xl sm:pb-5 md:text-6xl lg:text-7xl xl:text-8xl 2xl:text-8xl'>10 Điều Luật Hướng Đạo</h1>
          <span className='text-slate-300 pb-2 flex items-center justify-center font-bold text-lg sm:text-4xl sm:pb-5 md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-7xl'>Hướng đạo sinh</span>
          <ol className='text-slate-300 list-decimal pl-16 pt-5 text-2xl sm:text-5xl sm:pl-20 md:text-6xl md:pl-20 lg:text-7xl lg:pl-36 xl:text-8xl 2xl:text-8xl'>
            <li>Trọng Danh dự</li>
            <li>Trung thành</li>
            <li>Giúp ích</li>
            <li>Thân thiện</li>
            <li>Lễ độ</li>
            <li>Tôn trọng thiên nhiên</li>
            <li>Tôn trọng kỷ luật</li>
            <li>Vui tươi</li>
            <li>Cần kiệm</li>
            <li>Trong sạch</li>
          </ol>
        </div>
      </div>
    </div>
  )
}

export default Loi
